'use client';

import { styled } from '../../styles';

import { IconContainerVariant } from './types';

const getSizeByVariant = (variant: IconContainerVariant) => {
  if (variant === 'large') {
    return 32;
  }

  if (variant === 'medium') {
    return 24;
  }

  if (variant === 'small') {
    return 20;
  }

  return 16;
};

export const StyledIconContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: IconContainerVariant }>(({ variant }) => ({
  width: getSizeByVariant(variant),
  minWidth: getSizeByVariant(variant),
  maxWidth: getSizeByVariant(variant),
  height: getSizeByVariant(variant),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  svg: { width: '100%' },
}));
